import { styled } from 'styled-system/jsx'

const Card = styled('section', {
  base: {
    background:
      'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 244, 255, 0.95) 100%)',
    border: '1.5px solid rgba(128, 84, 255, 0.18)',
    borderRadius: 'lg',
    padding: '18px 22px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    boxShadow: '0 18px 48px -28px rgba(101, 56, 224, 0.35)',
  },
})

const Eyebrow = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'quickpass.primary',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
})

const Glyph = styled('span', {
  base: {
    fontSize: '14px',
  },
})

const Greeting = styled('h3', {
  base: {
    fontFamily: 'display',
    fontSize: '20px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.3px',
    lineHeight: '1.25',
  },
})

const Body = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.ink',
    margin: '0',
    lineHeight: '1.55',
  },
})

const NudgeRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginTop: '4px',
    flexWrap: 'wrap',
  },
})

const NudgeText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
  },
})

const NudgeButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    border: 'none',
    borderRadius: 'pill',
    paddingX: '12px',
    paddingY: '6px',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-1px)',
      boxShadow: '0 8px 22px -8px rgba(128, 84, 255, 0.45)',
    },
  },
})

const SkeletonLine = styled('div', {
  base: {
    backgroundColor: 'rgba(128, 84, 255, 0.1)',
    borderRadius: 'sm',
    height: '14px',
  },
})

const QuietText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
  },
})

export {
  Card,
  Eyebrow,
  Glyph,
  Greeting,
  Body,
  NudgeRow,
  NudgeText,
  NudgeButton,
  SkeletonLine,
  QuietText,
}
